module.exports = __webpack_public_path__ + "assets/img/1_1434_big.326cad03.jpg";